<div class="orders-statuses flex">
    @for (status of orderStatusKeys; track status) {
        <div class="status-count flex justify-center" [ngClass]="'status_' + status.toLowerCase() || 'status_destributed'">{{ordersStatusCount[status]}}</div>
    }
        <div>из {{allTasks.length}}</div>
</div>
